export const EMPLOYEE_STANDARD_OVERRIDES_WINDOW_CLASS = 'employee-standard-overrides-window';
export const CLOTHING_MARKER_OVERRIDES_WINDOW_CLASS = 'clothing-marker-overrides-window';
export const PAYROLL_CURRENCY_GROUP_TYPES = ['DEPARTMENT', 'AFFILIATE'];
export const WINDOW_RESIZE_HANDLER_PROPERTY = 'onresize';

export const VIEW_GROUP_ROUTE_PARAMETERS = {
	GROUP_ID: 'id',
	REPORT_MODE: 'rep'
};

export const VIEW_GROUP_MODAL_RESULT_OK = 'ok';
export const VIEW_GROUP_MODAL_SIZE_LARGE = 'lg';
export const VIEW_GROUP_VECTOR_STORAGE_KEY = 'dataList';
export const VIEW_GROUP_SHIFT_REFRESH_DELAY = 100;
export const VIEW_GROUP_MISSING_INDEX = -1;
export const VIEW_GROUP_FIRST_INDEX = 0;
export const VIEW_GROUP_FIRST_DISPLAY_INDEX = 1;
export const VIEW_GROUP_EMPTY_COUNT = 0;
export const VIEW_GROUP_EMPTY_TEXT = '';
export const VIEW_GROUP_NATIVE_NAME_PLACEHOLDERS = ['non data', 'no data'];
export const VIEW_GROUP_BOOLEAN_TYPE = 'boolean';
export const VIEW_GROUP_NOT_AVAILABLE_TEXT = 'N/A';

export const VIEW_GROUP_RELOAD_TARGETS = {
	CURRENT_GROUP: 'CURRENT_GROUP',
	AVAILABLE_GROUPS: 'AVAILABLE_GROUPS'
};

export const VIEW_GROUP_SCHEDULE_LABELS = {
	WORK: 'Work: ',
	REST: ' / Rest: ',
	SEPARATOR: ' | ',
	START_OF_SCHEDULER: 'Start of the scheduler: ',
	START_WORK: 'Start work: ',
	SPACE: ' ',
	END_WORK: ' - End work: ',
	PERIOD: '  Period: '
};

export const VIEW_GROUP_MEMBER_MESSAGES = {
	CHANGE_STATUS_PREFIX: 'Change the status of user ',
	TO_INACTIVE_SUFFIX: ' to inactive?',
	TO_ACTIVE_SUFFIX: ' to active?',
	CURRENT_POSITION_SEPARATOR: ' is currently a ',
	CURRENT_POSITION_SUFFIX: ' here. Please set a new ',
	RETRY_SUFFIX: ' first and then try again.'
};

export const VIEW_GROUP_PAYROLL_CURRENCY_I18N_KEYS = {
	UPDATED: 'DEPARTMENT_PAYROLL_CURRENCY_UPDATED',
	UPDATE_ERROR: 'DEPARTMENT_PAYROLL_CURRENCY_UPDATE_ERROR'
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/view-group.constants.ts